import '@splidejs/splide/dist/css/splide.min.css'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import Splide from '@splidejs/splide'

const defaultConfig = {
  type: 'slide',
  perPage: 1,
  perMove: 1,
  lazyLoad: 'nearby'
}

/**
 * Make carousel
 * @param {string} identifier
 * @param {object} config
 */
export const makeCarousel = (identifier, config = {}, multiple = false) => {
  if (multiple) {
    document.querySelectorAll(identifier).forEach(elem => {
      createCarousel(elem, config)
    })
  } else {
    return createCarousel(document.querySelector(identifier), config)
  }
}

const createCarousel = (elem, config) => {
  if (typeof config.perPage !== 'undefined' && elem.hasAttribute('data-nbslides')) {
    config.arrows = elem.dataset.nbslides > config.perPage
  }

  const slider = new Splide(elem, { ...defaultConfig, ...config }).mount()
  return slider
}
